import { Maybe } from "@mxt/zio/codec"
import { POApi } from "@pulseops/common"
import { pipe } from "fp-ts/lib/function"
import * as t from 'io-ts'
import { ACViewMetricListService } from "./ACViewMetricListService"
import { ZIO } from "@mxt/zio"

export namespace ACApprovalWorkflowService {
  export const ApprovalInfoRequest = t.type({
    requestId: t.number,
    status: t.string
  })

  export type ApprovalInfoRequest = t.TypeOf<typeof ApprovalInfoRequest>
  export const submitApproval = (bodyData: ApprovalInfoRequest) => pipe(
    POApi.internalPost(`internal/administration-rest/bsc/approve`)(t.type({
      data: t.array(ACViewMetricListService.ACSavedMetricListResponse),
      errors: Maybe(t.array(t.type({
        code: t.string,
        message: t.string
      })))
    }))(bodyData),
    ZIO.map((response) => {
      return response
    })
  )
  export const submitReject =  (bodyData: ApprovalInfoRequest) => pipe(
    POApi.internalPost(`internal/administration-rest/bsc/reject`)(t.type({
      data: t.array(ACViewMetricListService.ACSavedMetricListResponse),
      errors: Maybe(t.array(t.type({
        code: t.string,
        message: t.string
      })))
    }))(bodyData),
    ZIO.map((response) => {
      return response
    })
  )
}